import AjaxService from '@services/AjaxService';
import BaseRepository, {SelectOption} from '@repositories/desktop/BaseRepository';

export default class AreaRepository extends BaseRepository {
  protected baseUrl = '/api/desktop/areas';

  public constructor(protected readonly ajaxService: AjaxService) {
    super(ajaxService);
  }

  public create(attributes: any): Promise<any> {
    return this.ajaxService.postJson(`${this.baseUrl}`, {data: {attributes}});
  }

  public delete(id: number): Promise<any> {
    return this.ajaxService.sendDelete(`${this.baseUrl}/${id}/delete`);
  }

  public getAreaManagerOptions<T = number | string>(): Promise<Array<SelectOption<T>>> {
    return this.ajaxService.getJson(`${this.baseUrl}/options/area-manager`)
      .then(r => r.data.attributes.options);
  }

  public getBlank(): Promise<any> {
    return this.ajaxService.getJson(`${this.baseUrl}/blank`);
  }

  public loadOverview(id: number): Promise<any> {
    return this.ajaxService.getJson(`${this.baseUrl}/${id}`);
  }

  public saveBasedata(id: number, attributes: any): Promise<any> {
    return this.ajaxService.postJson(
      `${this.baseUrl}/${id}/basedata/save`,
      {data: {attributes}}
    );
  }
}
